import { lazy } from 'react';

import { useTranslation } from 'react-i18next';

import { useTheme } from '@pulse-web-ui/theme';

import { sendAnalyticEvent } from '@app/web-analytic';

import { useGetClaimsDraft } from '@entities/index';

import {
  AgentClaimType,
  AnalyticEvent,
  type CommonResponse,
  SectionHeader,
  useOpenFile,
} from '@shared/index';

import type { AgentProfileHeaderProps } from '../../model';
import {
  CreatedDocumentsContainer,
  DocumentItem,
  NameContainer,
} from './created-document.styles';

const ActIcon = lazy(() => import('@pulse-web-ui/icons/lib/lazy/act'));

interface CreatedDocumentsSectionProps {
  headerProps?: AgentProfileHeaderProps;
}
export const CreatedDocumentsSection = ({
  headerProps,
}: CreatedDocumentsSectionProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { fontSize, marginBottom } = headerProps || {};

  const { res, error, refetch, isFetching } = useGetClaimsDraft({
    claimType: AgentClaimType.PROFILE_UPDATE,
  });

  const onOpenFile = useOpenFile<CommonResponse>({
    res,
    error,
    isFetching,
    queryKeyToClearCache: 'getClaimsDraft',
  });

  const handleDocumentClick = () => {
    sendAnalyticEvent(AnalyticEvent.AGENT_EDITPERSONALDATA_PND_FORM);
    onOpenFile();
    refetch();
  };

  return (
    <CreatedDocumentsContainer>
      <SectionHeader
        $fontSize={fontSize}
        $marginBottom={marginBottom}
      >
        {t('AGENT_PROFILE:headers.createdDocuments')}
      </SectionHeader>
      <DocumentItem onClick={handleDocumentClick}>
        <ActIcon
          color={theme.colors.icon.primary}
          width={20}
        />
        <NameContainer>
          {t('AGENT_PROFILE:labels.documents.profileUpdateClaim')}
        </NameContainer>
      </DocumentItem>
    </CreatedDocumentsContainer>
  );
};
